// 使用 Vue CLI 标准环境变量
const apiBaseUrl = process.env.VUE_APP_API_BASE_URL
const envName = process.env.VUE_APP_ENV_NAME

console.log(`当前环境: ${envName}`)
console.log(`API地址: ${apiBaseUrl}`)

export default {
  api: apiBaseUrl,
  envName: envName
}
